<template>
  <div class="dating-bg">
    <div class="stars"></div>
    <div class="hearts"></div>
    
    <!-- 简化版樱花容器 -->
    <div class="sakura-container">
      <div v-for="n in 50" :key="n" :class="`sakura sakura-${n}`"></div>
    </div>
    
    <!-- 悬浮在背景墙右上角的语言选择器 -->
    <div class="floating-language">
      <ChangeLanguage />
    </div>
    
    <div class="login-wrapper">
      <div class="login-container">
        <div class="header">
         <!-- <i class="back-icon van-icon van-icon-cross" @click="back()"></i> -->
        </div>
        
        <div class="content-wrapper">
          <div class="logo-section">
            <div class="logo-circle">
              <img src="../../assets/img/logo2a.png" alt="Logo">
            </div>
            <h1 class="app-title">{{$t('login.doLogin')}}</h1>
          </div>
          
          <form class="login-form" @submit.prevent="doLogin">
            <div class="input-group">
              <div class="input-icon">
                <i class="icon-user"></i>
              </div>
              <input 
                type="text" 
                v-model="username" 
                :placeholder="$t('login.usernamePls')"
                class="styled-input"
                autocomplete="username"
              >
            </div>
            
            <div class="input-group">
              <div class="input-icon">
                <i class="icon-lock"></i>
              </div>
              <input 
                :placeholder="$t('login.passwordPls')" 
                v-model="password" 
                :type="passwordType"
                class="styled-input"
                autocomplete="current-password"
              >
              <div class="password-toggle" @click="switchPasswordType">
                <i :class="passwordType === 'password' ? 'icon-eye-closed' : 'icon-eye'"></i>
              </div>
            </div>
          </form>
          
          <!-- 修改登录按钮部分 -->
          <div 
            class="login-btn" 
            :class="btnState ? 'active' : ''" 
            @click="doLogin()"
          >
            <span>{{$t('login.doLogin')}}</span>
            <div class="btn-sparkle"></div>
          </div>
          
          <!-- 注册模块放在登录按钮下面 -->
          <div class="register-container">
            <div class="register-section">
              <a class="register-link" @click="toRegister()">
                <span class="register-text">{{$t('login.register')}}</span>
                <i class="register-arrow">→</i>
              </a>
            </div>
          </div>
          
          <div class="social-login">
            <div class="social-icons">
              <div class="social-icon">
                <i class="icon-kakao"></i>
              </div>
              <div class="social-icon">
                <i class="icon-line"></i>
              </div>
              <div class="social-icon">
                <i class="icon-instagram"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangeLanguage from '@/i18n/change-language'
import { Toast } from 'vant';
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {
    ChangeLanguage,
  },
  data() {
    return {
      username: '',
      password: '',
      passwordType: 'password',
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    btnState() {
      return this.username !== "" && this.password !== ""  // 移除 !isLoading 条件
    }
  },
  methods: {
    ...mapActions(['login']),
    
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    
    back() {
      if (this.$route.path !== '/') {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    
    toRegister() {
      if (this.$route.path !== '/Register') {
        this.$router.push("/Register")
      }
    },
    
    onSelect(action) {
      Toast(action.text);
    },
    
    async doLogin() {
      if (!this.username.trim()) {
        this.$toast(this.$t('login.usernamePls'));
        return false;
      }
      if (!this.password.trim()) {
        this.$toast(this.$t('login.passwordPls'));
        return false;
      }
    
      try {
        // 使用 Vuex action 进行登录
        const result = await this.login({
          username: this.username,
          password: this.password
        })
        
        this.$toast.success(result.msg);
        
        // 登录成功后跳转到个人中心
        if (this.$route.path !== '/Mine') {
          this.$router.push('/Mine')
        }
        
      } catch (error) {
        console.error('登录失败:', error)
        this.$toast(error.message || this.$t('login.loginFailed'));
      }
    }
  },
  created() {
    // 如果已登录，重定向到个人中心
    if (this.isLoggedIn && this.$route.path === '/Login') {
      this.$router.push('/Mine')
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/basenew.css";

// 变量定义 - 更新颜色
@primary-blue: #667eea;
@primary-purple: #764ba2;
@light-blue: #e6eeff;
@white: #ffffff;
@light-gray: #f5f5f5;
@text-dark: #333333;
@text-light: #888888;

// 动画定义
@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  33% { transform: translateY(-15px) rotate(5deg); }
  66% { transform: translateY(-8px) rotate(-3deg); }
}

@keyframes sparkle {
  0%, 100% { opacity: 0; transform: scale(0); }
  50% { opacity: 1; transform: scale(1); }
}

@keyframes twinkle {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.8; }
}

@keyframes bgShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

// 主样式 - 更新渐变背景色
.dating-bg {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(-45deg, #3498db, #8e44ad, #3498db, #8e44ad);
  background-size: 400% 400%;
  animation: bgShift 15s ease infinite;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: auto;
  
  // 星星背景
  .stars {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      radial-gradient(2px 2px at 20px 30px, #fff, transparent),
      radial-gradient(2px 2px at 40px 70px, #fff, transparent),
      radial-gradient(1px 1px at 90px 40px, #fff, transparent),
      radial-gradient(1px 1px at 130px 80px, #fff, transparent),
      radial-gradient(2px 2px at 160px 30px, #fff, transparent),
      radial-gradient(2px 2px at 200px 90px, #fff, transparent),
      radial-gradient(1px 1px at 250px 50px, #fff, transparent);
    background-repeat: repeat;
    animation: twinkle 6s ease-in-out infinite;
    z-index: 1;
  }
  
  // 心形装饰
  .hearts {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    
    &::before, &::after, &::first-line {
      content: "";
      position: absolute;
      color: rgba(255, 255, 255, 0.4);
      font-size: 24px;
      animation: float 8s ease-in-out infinite;
    }
    
    &::before {
      top: 15%;
      left: 10%;
      animation-delay: 0s;
    }
    
    &::after {
      top: 20%;
      right: 15%;
      animation-delay: 2s;
      content: "";
    }
    
    &::first-line {
      top: 70%;
      left: 5%;
      animation-delay: 4s;
      content: "";
    }
  }
}

// 增强版樱花飘落效果
// 替换现有的樱花样式
.sakura {
  position: absolute;
  top: -50px;
  width: 20px;
  height: 20px;
  opacity: 0.8;
  animation: sakura-fall linear infinite;
  user-select: none;
  z-index: 3;
  pointer-events: none;
}

// 创建樱花花瓣形状
.sakura::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 30% 30%, #ffb6c1 0%, #ff69b4 70%, transparent 70%),
    radial-gradient(circle at 70% 30%, #ffb6c1 0%, #ff69b4 70%, transparent 70%),
    radial-gradient(circle at 30% 70%, #ffb6c1 0%, #ff69b4 70%, transparent 70%),
    radial-gradient(circle at 70% 70%, #ffb6c1 0%, #ff69b4 70%, transparent 70%);
  border-radius: 50%;
  filter: blur(0.5px);
}

// 樱花飘落动画
@keyframes sakura-fall {
  0% {
    transform: translateY(-50px) translateX(0px) rotate(0deg);
    opacity: 0;
  }
  10% {
    opacity: 0.8;
  }
  90% {
    opacity: 0.6;
  }
  100% {
    transform: translateY(100vh) translateX(20px) rotate(360deg);
    opacity: 0;
  }
}

// 为每个樱花设置不同的样式和动画
.sakura-1 { 
  left: 5%; 
  animation-duration: 15s; 
  animation-delay: 0s; 
  width: 18px; height: 18px;
}
.sakura-2 { 
  left: 15%; 
  animation-duration: 18s; 
  animation-delay: 2s; 
  width: 22px; height: 22px;
}
.sakura-3 { 
  left: 25%; 
  animation-duration: 12s; 
  animation-delay: 1s; 
  width: 16px; height: 16px;
}
// ... 继续其他樱花的样式


// 悬浮语言选择器
.floating-language {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  
  /deep/ .change-language {
    .language-selector {
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(15px);
	  box-sizing: border-box;  /* 添加这个 */
      border: 3px solid rgba(255, 255, 255, 0.3);
      border-radius: 20px;
      padding: 10px 18px;
      color: @primary-blue;
      font-weight: 700;
      font-size: 18px;
      transition: all 0.3s;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      min-width: 80px;
      text-align: center;
      
      &:hover {
        background: rgba(255, 255, 255, 1);
        border-color: rgba(102, 126, 234, 0.6);
        transform: translateY(-2px);
        box-shadow: 0 12px 30px rgba(102, 126, 234, 0.25);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
  }
}

// 登录包装器 - 控制整体位置
.login-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  min-height: 100vh;
  box-sizing: border-box;
}

// 登录容器
.login-container {
  width: 94%;
  max-width: 440px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 25px 28px 30px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 80px rgba(102, 126, 234, 0.1);
  z-index: 10;
  position: relative;
  
  // 添加边框光泽效果 - 更新颜色
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 24px;
    padding: 2px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.4), rgba(118, 75, 162, 0.4));
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }
}

// 头部 - 更新后（移除了语言选择器）
.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  
  .back-icon {
    font-size: 22px;
    color: @text-dark;
    cursor: pointer;
    transition: all 0.3s;
    padding: 8px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.7);
    
    &:hover {
      color: @primary-blue;
      background: rgba(102, 126, 234, 0.1);
      transform: rotate(90deg);
    }
  }
}

// Logo区域
.logo-section {
  text-align: center;
  margin-bottom: 25px;
  
  .logo-circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: linear-gradient(135deg, @primary-blue, @primary-purple);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 15px;
    box-shadow: 0 8px 25px rgba(118, 75, 162, 0.4);
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: -10px;
      left: -10px;
      right: -10px;
      bottom: -10px;
      background: linear-gradient(135deg, transparent, rgba(255, 255, 255, 0.3), transparent);
      transform: rotate(45deg);
    }
    
    img {
      width: 60%;
      height: auto;
      z-index: 2;
      position: relative;
    }
  }
  
  .app-title {
    font-size: 26px;
    color: @text-dark;
    margin: 0;
    font-weight: 800;
    background: linear-gradient(135deg, @primary-blue, @primary-purple);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
}

// 表单
.login-form {
  margin-bottom: 15px;
}

.input-group {
  position: relative;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  
  .input-icon {
    position: absolute;
    left: 20px;
    z-index: 2;
    color: @text-light;
    
    &::before {
      font-size: 20px;
    }
  }
  
  .styled-input {
    width: 100%;
    height: 52px;
    border: none;
    border-radius: 26px;
    background: @light-gray;
    padding: 0 55px;
    font-size: 16px;
    transition: all 0.3s;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
    
    &:focus {
      outline: none;
      background: @white;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3), inset 0 2px 4px rgba(0, 0, 0, 0.05);
      transform: translateY(-2px);
    }
    
    &::placeholder {
      color: #bbb;
    }
  }
  
  .password-toggle {
    position: absolute;
    right: 20px;
    cursor: pointer;
    color: @text-light;
    transition: all 0.3s;
    padding: 8px;
    border-radius: 50%;
    
    &:hover {
      color: @primary-blue;
      background: rgba(102, 126, 234, 0.1);
    }
    
    &::before {
      font-size: 20px;
    }
  }
}

// 图标字体类
.icon-user::before { content: ""; }
.icon-lock::before { content: ""; }
.icon-eye::before { content: ""; }
.icon-eye-closed::before { content: "‍"; }
.icon-kakao::before { content: ""; }
.icon-line::before { content: ""; }
.icon-instagram::before { content: ""; }

// 登录按钮
.login-btn {
  width: 100%;
  height: 52px;
  border-radius: 26px;
  background: linear-gradient(to right, #3498db, #8e44ad);
  display: flex;
  justify-content: center;
  align-items: center;
  color: @white;
  font-size: 17px;
  font-weight: 700;
  cursor: not-allowed;
  margin-bottom: 16px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  
  &.active {
    background: linear-gradient(to right, @primary-blue, @primary-purple);
    cursor: pointer;
    box-shadow: 0 8px 25px rgba(118, 75, 162, 0.5);
    
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 30px rgba(118, 75, 162, 0.6);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 4px 15px rgba(118, 75, 162, 0.4);
    }
    
    .btn-sparkle {
      position: absolute;
      width: 20px;
      height: 20px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      animation: sparkle 2s infinite;
      
      &:nth-child(1) {
        top: 10px;
        left: 35px;
        animation-delay: 0s;
      }
      
      &:nth-child(2) {
        top: 6px;
        right: 45px;
        animation-delay: 0.7s;
      }
    }
  }
}

// 注册容器
.register-container {
  margin-bottom: 20px;
  
  .register-section {
    text-align: center;
    
    .register-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 12px 28px;
      background: rgba(255, 255, 255, 0.9);
      border: 2px solid rgba(102, 126, 234, 0.3);
      border-radius: 26px;
      color: @primary-blue;
      font-size: 15px;
      font-weight: 700;
      cursor: pointer;
      transition: all 0.3s;
      text-decoration: none;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
      
      &:hover {
        background: rgba(102, 126, 234, 0.1);
        border-color: rgba(102, 126, 234, 0.6);
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
        
        .register-arrow {
          transform: translateX(4px);
        }
      }
      
      .register-text {
        margin-right: 8px;
      }
      
      .register-arrow {
        font-size: 16px;
        transition: transform 0.3s;
      }
    }
  }
}

// 社交登录
.social-login {
  text-align: center;
  
  .social-icons {
    display: flex;
    justify-content: center;
    gap: 20px;
    
    .social-icon {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      background: @light-gray;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
      
      &:hover {
        transform: translateY(-5px) scale(1.1);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      }
      
      i::before {
        font-size: 20px;
      }
      
      // 为不同社交图标添加不同颜色效果
      &:nth-child(1):hover {
        background: #FFEB00; // Kakao黄色
        i::before { content: ""; }
      }
      
      &:nth-child(2):hover {
        background: #00B900; // Line绿色
        i::before { content: ""; }
      }
      
      &:nth-child(3):hover {
        background: linear-gradient(45deg, #FCAF45, #E1306C); // Instagram渐变
        i::before { content: ""; }
      }
    }
  }
}

// 响应式设计 - 手机端优化
@media (max-width: 480px) {
  .login-wrapper {
    padding: 40px 0 30px;
    align-items: center;
  }
  
  .login-container {
    width: 92%;
    max-width: none;
    padding: 20px 20px 25px;
    border-radius: 20px;
  }
  
  .header {
    margin-bottom: 18px;
    
    .back-icon {
      font-size: 20px;
      padding: 6px;
    }
  }
  
  // 樱花手机端适配
  .sakura {
    font-size: 20px;
  }
  
  .sakura-1 { font-size: 18px; }
  .sakura-2 { font-size: 16px; }
  .sakura-3 { font-size: 22px; }
  .sakura-4 { font-size: 15px; }
  .sakura-5 { font-size: 20px; }
  .sakura-6 { font-size: 18px; }
  .sakura-7 { font-size: 17px; }
  .sakura-8 { font-size: 21px; }
  .sakura-9 { font-size: 19px; }
  .sakura-10 { font-size: 16px; }
  .sakura-11 { font-size: 20px; }
  .sakura-12 { font-size: 17px; }
  .sakura-13 { font-size: 19px; }
  .sakura-14 { font-size: 18px; }
  .sakura-15 { font-size: 21px; }
  
  // 悬浮语言选择器手机端适配
  .floating-language {
    top: 20px;
    right: 20px;
    
    /deep/ .change-language .language-selector {
      padding: 10px 16px;
      font-size: 16px;
      min-width: 80px;
    }
  }
  
  .logo-section {
    margin-bottom: 22px;
    
    .logo-circle {
      width: 85px;
      height: 85px;
      margin-bottom: 12px;
    }
    
    .app-title {
      font-size: 24px;
    }
  }
  
  .input-group {
    margin-bottom: 16px;
    
    .styled-input {
      height: 50px;
      padding: 0 50px;
      font-size: 15px;
    }
    
    .input-icon, .password-toggle {
      &::before {
        font-size: 18px;
      }
    }
  }
  
  .login-btn {
    height: 50px;
    font-size: 16px;
    margin-bottom: 14px;
  }
  
  .register-container {
    margin-bottom: 18px;
    
    .register-section .register-link {
      padding: 10px 24px;
      font-size: 14px;
    }
  }
  
  .social-icons {
    gap: 18px;
    
    .social-icon {
      width: 42px;
      height: 42px;
      
      i::before {
        font-size: 18px;
      }
    }
  }
}

// 平板和桌面端优化
@media (min-width: 768px) {
  .login-wrapper {
    padding: 30px 0;
  }
  
  .login-container {
    max-width: 420px;
    padding: 30px 32px 35px;
  }
  
  .floating-language {
    top: 25px;
    right: 25px;
  }
  
  .logo-section .logo-circle {
    width: 95px;
    height: 95px;
  }
  
  .app-title {
    font-size: 28px;
  }
}

// 大桌面端优化
@media (min-width: 1200px) {
  .login-wrapper {
    padding: 40px 0;
  }
  
  .login-container {
    max-width: 440px;
    padding: 35px 40px 40px;
  }
  
  .floating-language {
    top: 30px;
    right: 30px;
  }
}
</style>